module.exports = __webpack_public_path__ + "static/media/ball.aecbfb55.mp3";